import React, {Component} from 'react'
import SomethingWentWrong from '../../assets/images/something-went-wrong.png'

const style = {
  width: '700px',
  height: '400px',
  marginTop: '100px',
  marginLeft: 'auto',
  marginRight: 'auto',
  display: 'block',
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = {error: null, errorInfo: null}
  }

  componentDidCatch(error, info) {
    this.setState({error: error, errorInfo: info})
  }

  render() {
    if (this.state.errorInfo) {
      return (
        <div className="error-boundary">
          <img src={SomethingWentWrong} alt="Something went wrong " style={style} />
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
